import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: ${tokens.typography.fontFamily.primary};
`

export const Text = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${tokens.color.text.secondary};
`
